module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-manager"
  }, [_c('div', {
    staticClass: "order-manager-search white-box"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("订单编号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入订单编号"
    },
    model: {
      value: (_vm.filterTerm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "orderNo", $$v)
      },
      expression: "filterTerm.orderNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入商品名称"
    },
    model: {
      value: (_vm.filterTerm.commodityName),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "commodityName", $$v)
      },
      expression: "filterTerm.commodityName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "commodityType", $$v)
      },
      expression: "filterTerm.commodityType"
    }
  }, _vm._l((_vm.goodsTypeOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("订单渠道")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.promotorId),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "promotorId", $$v)
      },
      expression: "filterTerm.promotorId"
    }
  }, _vm._l((_vm.orderChannelOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("订单状态")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.orderStatus),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "orderStatus", $$v)
      },
      expression: "filterTerm.orderStatus"
    }
  }, _vm._l((_vm.orderStatusOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("来源子站")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filterTerm.sourceSubsiteId),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "sourceSubsiteId", $$v)
      },
      expression: "filterTerm.sourceSubsiteId"
    }
  }, _vm._l((_vm.sourceStationOptions), function(item) {
    return _c('el-option', {
      key: item.subSiteId,
      attrs: {
        "label": item.subSiteName,
        "value": item.subSiteId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("用户昵称")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入用户昵称"
    },
    model: {
      value: (_vm.filterTerm.buyerNickName),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "buyerNickName", $$v)
      },
      expression: "filterTerm.buyerNickName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("用户手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入用户手机号"
    },
    model: {
      value: (_vm.filterTerm.buyerMobile),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "buyerMobile", $$v)
      },
      expression: "filterTerm.buyerMobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part choose-time"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择起始日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtFrom),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtFrom", $$v)
      },
      expression: "filterTerm.createdAtFrom"
    }
  }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择终止日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtTo),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtTo", $$v)
      },
      expression: "filterTerm.createdAtTo"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('a', {
    staticClass: "order-export",
    attrs: {
      "href": ("" + _vm.PROTOCOL + _vm.HOST + "/orderMgmt/order/export?" + _vm.requireData),
      "target": "_blank",
      "download": "订单.xlsx"
    }
  }, [_c('el-button', [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box order-manager-table"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('span', [_vm._v("订单列表")]), _vm._v(" "), _c('span', {
    staticClass: "order-tips",
    on: {
      "click": _vm.toOrderTips
    }
  }, [_vm._v("佣金和分成比例不吻合？")])]), _vm._v(" "), _c('table', {
    staticClass: "xmly-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderTableData), function(order) {
    return _c('tbody', {
      key: order.orderNo
    }, [_c('tr', {
      staticClass: "order"
    }, [_c('td', [_vm._v(_vm._s(("订单编号：" + (order.orderNo))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "column-content"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": order.coverUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h2', {
      staticClass: "tit elli"
    }, [_vm._v(_vm._s(order.commodityName))]), _vm._v(" "), _c('p', {
      staticClass: "price elli"
    }, [_vm._v(_vm._s(("售价：￥" + (order.commodityPrice))))]), _vm._v(" "), _c('p', {
      staticClass: "count elli"
    }, [_vm._v(_vm._s(("数量：" + (order.commodityAmount))))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.commodityType))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "name elli"
    }, [_vm._v(_vm._s(order.buyerNickName))]), _vm._v(" "), _c('p', {
      staticClass: "tel elli"
    }, [_vm._v(_vm._s(order.buyerMobile))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.orderAmount))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.orderStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.brokerageRatios))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.brokerageAmount))))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "elli"
    }, [_vm._v(_vm._s(order.promotorType))]), _vm._v(" "), _c('p', {
      staticClass: "elli"
    }, [_vm._v(_vm._s(order.promotorName))])]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "elli"
    }, [_vm._v(_vm._s(order.sourceSubsiteName))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.createdAt))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "order-manager-pag column-content white-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.filterTerm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.curPage = $event
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('th', [_vm._v("用户")]), _vm._v(" "), _c('th', [_vm._v("订单金额（元）")]), _vm._v(" "), _c('th', [_vm._v("订单状态")]), _vm._v(" "), _c('th', [_vm._v("分成比例")]), _vm._v(" "), _c('th', [_vm._v("佣金（元）")]), _vm._v(" "), _c('th', [_vm._v("订单渠道")]), _vm._v(" "), _c('th', [_vm._v("来源")]), _vm._v(" "), _c('th', [_vm._v("创建时间")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-392f84a2","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/orderManager/index.vue
// module id = 935
// module chunks = 1